document.addEventListener('DOMContentLoaded', function () {
  var resizeTimer;

  function initRelatedBlogsSlider() {
    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
      return;
    }

    var $ = window.jQuery;

    $('.custom-related-blogs').each(function () {
      var $section = $(this);
      var $slider = $section.find('.custom-related-blogs__slider');
      var $progressBar = $section.find('.custom-related-blogs__progress span');
      var $prevArrow = $section.find('.related-prev');
      var $nextArrow = $section.find('.related-next');

      if (!$slider.length) return;

      function updateProgress(event, slick, currentSlide) {
        var currentIndex = currentSlide || 0;
        var slidesToShow = slick.options.slidesToShow;
        var total = slick.slideCount;

        var progress = ((currentIndex + slidesToShow) / total) * 100;

        if (progress > 100) {
          progress = 100;
        }

        $progressBar.css('width', progress + '%');
      }

      if (window.innerWidth <= 989) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.on('init reInit afterChange', updateProgress);

          $slider.slick({
            slidesToShow: window.innerWidth <= 749 ? 1 : 2,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            speed: 300,
            adaptiveHeight: false,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow
          });
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

        $progressBar.css('width', '0%');
      }
    });
  }

  initRelatedBlogsSlider();

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      if (typeof window.jQuery !== 'undefined') {
        $('.custom-related-blogs__slider.slick-initialized').slick('unslick');
      }

      initRelatedBlogsSlider();
    }, 250);
  });
});